import { useState } from 'react';
import './App.css';
import SearchResults from './SearchResults.js';

import { Button, Input } from 'antd';

const apiKey = localStorage.getItem('apiKey')

const fetchResults = async (q) => {
  if(!apiKey) throw new Error('401 Unauthorized');
  const resp = await fetch(`/api/v1/search?q=${q}`, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${apiKey}`,
    }
  });
  return resp.json();
}

function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const submitSearch = async (evt) => {
    if (searchQuery.length < 3) throw new Error('minimum 3')
    const results = await fetchResults(searchQuery)
    setSearchResults(results.matches);
  }

  const searchInputChange = (evt) => {
    const { value } = evt.target;
    setSearchQuery(value);
  }

  return (
    <div className="App">
      <Input onChange={searchInputChange} placeholder='termini di ricerca' />
      <Button type='primary' onClick={submitSearch}>Search</Button>
      <SearchResults searchResults={searchResults} />
    </div>
  );
}

export default App;
